<nz-card class="round-border p-4" [nzLoading]="!loaded">
    <a [routerLink]="['/audio-description']">
        <nz-statistic [nzValue]="count | number" [nzTitle]="'audio-description_common_name' | translate"></nz-statistic>
    </a>
</nz-card>